import ArrowLeft from 'assets/icons/base/arrow-left.svg';
import { PAY_METHOD } from 'constants/payment';
import { useAmount, useTranslate, useYM } from 'hooks';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setAcquiring } from 'store/payment/slice';
import { CardForm } from 'views/forms/base/pay-forms';
import { PhoneForm } from 'views/forms/base/pay-forms/phone-form';
import { Plus24Form } from 'views/forms/base/pay-forms/plus24-form';

import { TitlePaymentMethod } from '../title-payment-method';

const renderFormType = {
  [PAY_METHOD.BANK_CARD_1]: <CardForm />,
  [PAY_METHOD.BANK_CARD_3]: <CardForm />,
  [PAY_METHOD.BANK_CARD_9]: <CardForm />,
  [PAY_METHOD.PLUS24_2]: <Plus24Form />,
  [PAY_METHOD.PLUS24_7]: <Plus24Form />,
  [PAY_METHOD.MOBILE]: <PhoneForm />,
};

const FormType = () => {
  const { acquiring, isPayment, paymentData, isOnlyBankCard } = useAppSelector(
    (state) => state.payment,
  );
  const { currentAmount, isValidCurrentAmount, commission } = useAmount();
  const { t } = useTranslate();
  const { trackOnClick } = useYM();
  const dispatch = useAppDispatch();

  const closeFormType = () => {
    trackOnClick(`Другие способы ${isPayment ? 'оплаты' : 'выплаты'}`);
    dispatch(setAcquiring(null));
  };

  return (
    paymentData &&
    acquiring && (
      <div className="w-full grid md:block grid-rows-[auto_auto_1fr] flex-grow">
        {!isOnlyBankCard && (
          <button
            type="button"
            onClick={closeFormType}
            className="hidden md:flex items-center gap-2 text-base-blue-100 font-bold leading-5 text-sm hover:underline mb-8"
          >
            <img src={ArrowLeft} alt="arrow left" width={12} height={12} />
            {isPayment ? t('lang.other_pay_methods') : t('lang.other_payout_methods')}
          </button>
        )}

        <TitlePaymentMethod closePaymentMethod={closeFormType} />
        <div>
          <dl className="flex md:hidden justify-between items-center mt-4">
            <dt className="text-sm leading-140 font-semibold">{t('1xbet.payment-amount')}</dt>
            <dd className="text-base leading-140 font-bold">{currentAmount} ₸</dd>
          </dl>
          {Number(commission) > 0 && (
            <dl className="flex md:hidden justify-between items-center mt-4">
              <dt className="text-sm leading-140 font-semibold">{t('commission')}</dt>
              <dd className="text-base leading-140 font-bold">{commission} ₸</dd>
            </dl>
          )}
        </div>

        {!isValidCurrentAmount && (
          <p className="text-base-red-200 text-sm">
            {t('lang.payment_cannot_be_less_than_commission')}
          </p>
        )}
        {renderFormType[acquiring.formType]}
      </div>
    )
  );
};

export { FormType };
